import { saveAs } from "file-saver";
import * as xlsx from "xlsx";


// convert Json to CSV and download file
const useConvertToCSV = (res) => {
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const { list, header } = res
    // const csvData = list.map((item) => {
    //     const obj = {}
    //     header?.forEach((head) => {
    //         obj[head.name] = head.FN ? head.FN(item) : item[head.key]
    //     })
    //     return obj
    // })
    // const wb = xlsx.utils.book_new()
    // const wsAll = xlsx.utils.json_to_sheet(csvData)
    // xlsx.utils.book_append_sheet(wb, wsAll, "SheetJS")
    // const wbout = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' })
    // const s2ab = (s) => {
    //     const buf = new ArrayBuffer(s.length)
    //     const view = new Uint8Array(buf)
    //     for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    //     return buf
    // }
    // saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "download.xlsx")
    if (list.length > 0) {
        const ws = xlsx.utils.json_to_sheet(list);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        const fileSaved = saveAs(data, "Excel" + fileExtension);
        console.log('fileSaved :', fileSaved);
    }
}


export default useConvertToCSV